import React, { useState } from 'react'
import { Formik, Form, Field } from 'formik'
import { format, addYears } from 'date-fns'
import { FiEdit, FiSave } from 'react-icons/fi'
import { FaRegSave } from 'react-icons/fa'
import { toast } from 'react-toastify'

import Yup from '../../../services/yup'

import Spinner from '../../../components/Spinner'
import Modal from '../../../components/Modal'
import ActionFooter from '../../../components/ActionFooter'
import { Textbox, Button } from '../../../components/Form'

import masks from '../../../util/masks'
import { stringToDate, getDate } from '../../../util/date'

import { api, authHeaders } from '../../../services/api'

import { Container, ModalContainer } from './styles'

const baseInitialValues = {
    nascimento: ''
}

const boxName = 'Dados pessoais'
const idadeMinima = 20

const validation = Yup.object().shape({
    nascimento: Yup.string()
        .date({ max: { value: addYears(new Date(), -idadeMinima), message: `A idade mínima é ${idadeMinima} anos.` } })
        .required('Especifique a data de nascimento.')
})

export default function ({ pessoa, reload, editable = true }) {
    const [editMode, setEditMode] = useState(false)
    const [initialValues, setInitialValues] = useState(baseInitialValues)

    async function handlePrepareEdit() {
        const {
            data_nascimento
        } = pessoa

        setInitialValues({
            nascimento: data_nascimento ? format(stringToDate(data_nascimento), 'dd/MM/yyyy') : ''
        })

        setEditMode(true)
    }

    async function handleEdit(values) {
        try {
            const {
                nascimento
            } = values

            await api.put(`pessoa/${pessoa.id}`, {
                data_nascimento: getDate(nascimento)
            }, authHeaders())

            toast.success('Dados atualizados.')

            setEditMode(false)

            setInitialValues(baseInitialValues)

            reload()
        } catch (e) {
            toast.error('Erro ao atualizar os dados pessoais.')
        }
    }

    return (
        <>
            <Container className="animated fadeInUp delay-200ms no-responsive text-slate-800 bg-white">
                <h1 className="text-slate-800">Dados pessoais</h1>

                {editable ? (
                    <div
                        className="flex items-center gap-1.5 cursor-pointer hover:opacity-80 w-fit hover:bg-slate-100 rounded-md px-4 py-2 justify-self-end"
                        onClick={handlePrepareEdit}
                    >
                        <FiEdit
                            size={18}
                            color="#1e293b"
                        />

                        <span className="text-center text-xs">Editar</span>
                    </div>
                ) : (
                    <div />
                )}

                <div />

                {pessoa ? (
                    <div className="pessoal" dangerouslySetInnerHTML={{
                        __html: `<b>Data nascimento:</b>&nbsp;${pessoa.dados_pessoais?.data_nascimento || ''}`
                    }} />
                ) : (
                    <Spinner />
                )}
            </Container>

            <Modal
                isOpen={editMode}
                handleClose={() => setEditMode(false)}
                title={boxName}
            >
                <ModalContainer>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validation}
                        onSubmit={editMode ? handleEdit : () => null}
                        enableReinitialize
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                <Field type="hidden" name="cpf_id" />

                                <Field type="hidden" name="rg_id" />

                                <Textbox
                                    label="Data de nascimento"
                                    name="nascimento"
                                    mask={masks.date}
                                />

                                <ActionFooter>
                                    <Button type="submit" loading={isSubmitting} className="button">
                                        Salvar alterações
                                        <FiSave size={16} />
                                    </Button>
                                </ActionFooter>
                            </Form>
                        )}
                    </Formik>
                </ModalContainer>
            </Modal>
        </>
    )
}
